module.exports = __webpack_public_path__ + "static/img/SearchDetailRetirement2.e018ef8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailRetirement2.png
// module id = 773
// module chunks = 0